<template>
  <el-row
    :class="[
      'taxation-status fs-14',
      ndsStatusConfig[status || 'not_stated'].color,
    ]"
  >
    {{ ndsStatusConfig[status || 'not_stated'].text }}
  </el-row>
</template>

<script>
import { ndsStatusConfig } from './constants'

export default {
  name: 'TaxationStatus',
  props: {
    status: {
      type: String,
      default: 'not_stated',
    },
  },
  data() {
    return {
      ndsStatusConfig,
    }
  },
}
</script>

<style lang="sass">
.taxation-status
  &.green
    color: #589839
  &.grey
    color: #b7b7b7
  &.gold
    color: darkgoldenrod
</style>
